module.exports = __webpack_public_path__ + "img/logo.b0f71523.png";